// src/pages/ClinicalDataCollector/ClinicalDataCollectorPage.jsx

import React from 'react';
import { Container, Grid, Box, Typography, Divider } from '@mui/material';
import {
  ClinicalSummary,
  HCCConditionsList,
  TreatmentPlan,
  RAFScore,
  RiskCodingAnalysis,
  HEDISMetricsReport,
  PreventiveServicesReport,
  ChronicConditionsSection,
  MedicationDetailTable,
  HypertensionSection,
  CVRiskScore10Y,
  AFSection,
  HeartFailureSection,
  COPDSection,
  AsthmaSection,
  ProviderEncounterTable,
  SpecialistNotesSection,
} from './components/output';

const ClinicalDataCollectorPage = () => (
  <Container maxWidth="xl" sx={{ py: 4 }}>
    <Typography variant="h4" align="center" gutterBottom fontWeight="bold">
      🩺 Clinical Data Collector
    </Typography>
    <Divider sx={{ mb: 4 }} />

    {/* RESUMEN INICIAL */}
    <Box sx={{ mb: 6 }}>
      <ClinicalSummary />
    </Box>

    <Grid container spacing={4} justifyContent="center">
      {/* SECCIÓN DE CONDICIONES Y RIESGO */}
      <Grid item xs={12} sm={6}>
        <HCCConditionsList />
      </Grid>
      <Grid item xs={12} sm={6}>
        <RAFScore />
      </Grid>

      <Grid item xs={12}>
        <RiskCodingAnalysis />
      </Grid>

      {/* SECCIÓN DE TRATAMIENTO */}
      <Grid item xs={12}>
        <TreatmentPlan />
      </Grid>

      {/* MÉTRICAS Y PREVENCIÓN */}
      <Grid item xs={12} sm={6}>
        <HEDISMetricsReport />
      </Grid>
      <Grid item xs={12} sm={6}>
        <PreventiveServicesReport />
      </Grid>

      {/* CONDICIONES CRÓNICAS Y MEDICACIÓN */}
      <Grid item xs={12}>
        <ChronicConditionsSection />
      </Grid>

      <Grid item xs={12}>
        <MedicationDetailTable />
      </Grid>

      {/* RIESGOS Y CONDICIONES ESPECÍFICAS */}
      <Grid item xs={12}>
        <HypertensionSection />
      </Grid>

      <Grid item xs={12}>
        <CVRiskScore10Y />
      </Grid>

      <Grid item xs={12} sm={6}>
        <AFSection />
      </Grid>
      <Grid item xs={12} sm={6}>
        <HeartFailureSection />
      </Grid>

      <Grid item xs={12} sm={6}>
        <COPDSection />
      </Grid>
      <Grid item xs={12} sm={6}>
        <AsthmaSection />
      </Grid>

      {/* ENCUENTROS Y NOTAS DE ESPECIALISTAS */}
      <Grid item xs={12}>
        <ProviderEncounterTable />
      </Grid>

      <Grid item xs={12}>
        <SpecialistNotesSection />
      </Grid>
    </Grid>
  </Container>
);

export default ClinicalDataCollectorPage;